import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cache', standalone: true })
export class CachePipe implements PipeTransform {
    private lastKey?: string;
    private lastValue?: unknown;

    transform<T>(value: T): T {
        const key = JSON.stringify(value);
        if (key !== this.lastKey) {
            this.lastKey = key;
            this.lastValue = value;
        }
        return this.lastValue as T;
    }
}
